import { render, staticRenderFns } from "./LinkForm.vue?vue&type=template&id=9b1a9164"
import script from "./LinkForm.vue?vue&type=script&lang=js"
export * from "./LinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports